export default {
      id: "ic_unfollow_user-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_unfollow_user-usage",
      toString: function () {
        return this.url;
      }
    }